var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24337 5.82665C8.8541 5.82665 10.1598 4.52231 10.1598 2.91332C10.1598 1.30434 8.8541 0 7.24337 0C5.63264 0 4.32689 1.30434 4.32689 2.91332C4.32689 4.52231 5.63264 5.82665 7.24337 5.82665Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00772 7.96362C7.76591 7.8576 7.50464 7.80286 7.24048 7.80286C6.97632 7.80286 6.71505 7.8576 6.47324 7.96362C6.14461 8.09993 5.87929 8.35432 5.72982 8.67642L5.6631 8.80947L0.230447 21.8488C0.230447 21.8488 -0.90374 24.4529 1.86024 23.7496C1.86024 23.7496 7.42633 20.8984 12.7827 23.8257C12.8479 23.8668 12.9185 23.8988 12.9924 23.9207C13.4213 24.0347 14.7747 24.2818 14.4316 22.4666C14.4228 22.4006 14.4035 22.3364 14.3744 22.2765L8.82739 8.82848C8.77752 8.72317 8.72019 8.62154 8.65583 8.52435C8.51501 8.26535 8.28472 8.06611 8.00772 7.96362Z",
    fill: "#E5E5E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7566 5.82665C26.3673 5.82665 27.6731 4.52231 27.6731 2.91332C27.6731 1.30434 26.3673 0 24.7566 0C23.1459 0 21.8401 1.30434 21.8401 2.91332C21.8401 4.52231 23.1459 5.82665 24.7566 5.82665Z",
    fill: "#2B3081"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9923 23.839C24.2341 23.9452 24.4954 24 24.7595 24C25.0237 24 25.285 23.9452 25.5268 23.839C25.854 23.6955 26.1182 23.4385 26.2702 23.1154L26.3369 22.9821L31.7696 9.95781C31.7696 9.95781 32.9038 7.34915 30.1398 8.05368C30.1398 8.05368 24.5737 10.9099 19.2173 7.97751L19.0076 7.88231C18.5787 7.76806 17.2253 7.52052 17.5684 9.33897C17.5786 9.40784 17.5978 9.47507 17.6256 9.5389L23.1726 22.9726C23.2225 23.0781 23.2798 23.1799 23.3442 23.2772C23.4821 23.539 23.7134 23.7394 23.9923 23.839Z",
    fill: "#2B3081"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.643fa461152cd90d913d66a7ce211154.svg";
export { ForwardRef as ReactComponent };